import React, { useState } from "react";
import { Link } from "react-router-dom";
import { PetCard } from "@miezmission/ui";
import type { PetState } from "@miezmission/shared-types";
import { PetMood } from "@miezmission/shared-types";

const mockPet: PetState = {
  id: "pet-1",
  familyId: "family-1",
  name: "Miezepups",
  happiness: 75,
  streakDays: 3,
  lastInteractionAt: new Date(),
  mood: PetMood.Happy,
  level: 2,
  experiencePoints: 850,
  createdAt: new Date(),
  updatedAt: new Date(),
};

export function PetPage(): React.ReactElement {
  const [pet] = useState<PetState>(mockPet);

  return (
    <div className="min-h-screen p-6 flex flex-col gap-6">
      <div className="flex items-center gap-2">
        <Link to="/" className="text-purple-600 hover:text-purple-800 font-medium">
          ← Zurück
        </Link>
      </div>
      <PetCard pet={pet} />
      <div className="text-center text-sm text-gray-400">
        Erledige Routinen, um deine Katze glücklich zu machen! 🎉
      </div>
    </div>
  );
}
